export const GetAnswerList = async (data) => {
    let answerList = [];
    // console.log(data)
    for (let i in data) {
        try {
            if (data[i].questionsTypeId == '8' || data[i].questionsTypeId == '12' || (data[i].questionsTypeId == '6' && data[i].cutType == 7)) {
                let value = '';
                for (let j in data[i].optionList) {
                    if (data[i].optionList[j].oid == data[i].userAnswer && data[i].optionList[j].haveInput == true) {
                        value = `${data[i].userAnswer}:${data[i].optionList[j].inputValue}`;
                    } else {
                        value = data[i].userAnswer;
                    }
                }
                answerList.push({
                    qid: data[i].qid,
                    value: value ? value : '',
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == '10' || (data[i].questionsTypeId == '6' && data[i].cutType == 8)) {
                // console.log(data[i])
                let value = '',
                    str = '',
                    arr = [];
                data[i].optionList.forEach(item => {
                    if (data[i].userAnswerArr.indexOf(item.oid) != -1 && item.haveInput == true) {
                        value = `${item.oid}:${item.inputValue}`;
                        arr.push(value);
                    } else if (data[i].userAnswerArr.indexOf(item.oid) != -1) {
                        value = item.oid;
                        arr.push(value);
                    }
                });
                if (arr) {
                    str = arr.join();
                }
                answerList.push({
                    qid: data[i].qid,
                    value: str,
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == '35' || data[i].questionsTypeId == '34' || data[i].questionsTypeId == '37') {
                let arr = [];
                data[i].optionList.forEach(el => {
                    arr.push({
                        oid: el.oid,
                        value: el.userAnswer
                    });
                });
                answerList.push({
                    qid: data[i].qid,
                    optionValue: arr,
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == '33') {
                answerList.push({
                    qid: data[i].qid,
                    value: data[i].userAnswerArr.length > 0 ? data[i].userAnswerArr.join() : '',
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == '14') {
                // let quesArr = [];
                data[i].userAnswerArr = data[i].userAnswerArr.map(info => {
                    // quesArr.push({ oid: info });
                    data[i].sortArray.forEach(item => {
                        if (info == item.oid && item.haveInput == true) {
                            info = `${info}:${item.inputValue}`
                        }
                    })
                    return info
                });
                // console.log(data[i].userAnswerArr)
                answerList.push({
                    qid: data[i].qid,
                    value: data[i].userAnswerArr,
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == '19' || data[i].questionsTypeId == '20' || data[i].questionsTypeId == '21' || data[i].questionsTypeId == '22') {
                answerList.push({
                    qid: data[i].qid,
                    SonValue: data[i].userAnswerArr,
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            }else if (data[i].questionsTypeId == '39') {
                if(data[i].tip && data[i].tip != '') {
                    try {
                        data[i].userAnswerArr = data[i].userAnswerArr.map((info, index) => {
                            if (index + 1 == data[i].userAnswerArr.length) {
                                info.optionValue[1].value = data[i].tip
                            }
                            return info
                        })
                    } catch (error) {
                        console.log('error :>> ', error);
                    }
                }
                answerList.push({
                    qid: data[i].qid,
                    SonValue: data[i].userAnswerArr,
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == '16') {
                answerList.push({
                    qid: data[i].qid,
                    value: data[i].userAnswerArr,
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == '36') {
                console.log(' data[i]', data[i])
                answerList.push({
                    qid: data[i].qid,
                    value: data[i].optionValue,
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId == 11) {
                // console.log(data[i])
                answerList.push({
                    qid: data[i].qid,
                    value: data[i].userAnswer > -1 ? data[i].userAnswer : '',
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            } else if (data[i].questionsTypeId != '26' && data[i].questionsTypeId != '25') {
                // console.log(data[i])
                answerList.push({
                    qid: data[i].qid,
                    value: data[i].userAnswer ? data[i].userAnswer : '',
                    isShow: data[i].isShow && data[i].bindIsShow ? true : false
                });
            }
        } catch (error) {}
    }
    return answerList;
}